export function _formatAmount(amount) {
  if (!amount) return '0';
  const num = Math.floor(Number(amount));
  return num.toLocaleString('ko-KR');
}

export function _setStorageWithExpiry(key, value) {
  sessionStorage.setItem(key, JSON.stringify({ value }));
}

export function _getStorageWithExpiry(key) {
  const itemStr = sessionStorage.getItem(key);
  if (!itemStr) return null;

  const item = JSON.parse(itemStr);
  if (Date.now() > item.expiry) {
    sessionStorage.removeItem(key);
    return null;
  }
  return item.value;
}

export function _getIsGonggu() {
  // const s_id = _getStorageWithExpiry('s_id');
  // const encoded = _getStorageWithExpiry('sy');
  // return (s_id != '' && s_id != null) || atob(encoded) === 'Y';
  return true;
}

export function _getIsPassed(start, end, openTime) {
  const now = new Date();
  const startAt = _toDateAtHour(start, Number(openTime ?? 0));
  const endAt = _toEndOfDay(end);

  return now < startAt || now > endAt;
}

export function _getPeriodStatus(data) {
  const start = data.var2;
  const gongguEnd = data.var3;
  const end = data.var9;
  const openTime = data.open_time;

  const now = new Date();
  const startAt = _toDateAtHour(start, Number(openTime ?? 0));
  const gongguEndAt = _toEndOfDay(gongguEnd);
  const endAt = _toEndOfDay(end);

  // 1. 구매 기간 시작 전
  if (now < startAt) {
    const diffTime = startAt.getTime() - now.getTime();
    const daysLeft = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return { status: 'before', daysLeft };
  }

  // 2. 공동구매 기간
  if (now >= startAt && now <= gongguEndAt) {
    const diffTime = gongguEndAt.getTime() - now.getTime();
    const daysLeft = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return { status: 'ing', daysLeft };
  }

  // 3. 일반 판매 기간
  if (now > gongguEndAt && now <= endAt) {
    const diffTime = endAt.getTime() - now.getTime();
    const daysLeft = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return { status: 'default', daysLeft };
  }

  return { status: 'passed', daysLeft: 0 };
}

function _toDateAtHour(dateLike, hour) {
  const d = dateLike instanceof Date ? dateLike : new Date(dateLike);
  return new Date(d.getFullYear(), d.getMonth(), d.getDate(), hour, 0, 0, 0);
}

function _toEndOfDay(dateLike) {
  const d = dateLike instanceof Date ? dateLike : new Date(dateLike);
  return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999);
}

export function _getDiscountPercent(costPrice, retailPrice) {
  const cost = Number(costPrice);
  const retail = Number(retailPrice);

  if (!Number.isFinite(cost) || !Number.isFinite(retail) || cost <= 0) return 0;

  const percent = ((cost - retail) / cost) * 100;

  if (!Number.isFinite(percent) || percent <= 0) return 0;

  return Math.min(100, Math.floor(percent)); // 기본: 내림
}

export function _getRemainingTime(endAt) {
  const endMs = endAt instanceof Date ? endAt.getTime() : new Date(endAt).getTime();
  const nowMs = Date.now();
  const diff = Math.max(0, endMs - nowMs);

  const totalSeconds = Math.floor(diff / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const pad2 = n => String(n).padStart(2, '0');

  return {
    done: diff === 0,
    days,
    hours,
    minutes,
    seconds,
    text: `${days}일 ${pad2(hours)} : ${pad2(minutes)} : ${pad2(seconds)}`,
    daysText: `${days}일`,
    hmsText: `${pad2(hours)} : ${pad2(minutes)} : ${pad2(seconds)}`,
  };
}

export function _safeAtob(value, fallback = '') {
  if (!value) return fallback;
  try {
    return atob(value);
  } catch (e) {
    return fallback;
  }
}

export function _safeBtoa(value, fallback = '') {
  if (value === null || value === undefined) return fallback;
  const str = String(value);
  if (str.trim() === '' || str === '0') return fallback;

  try {
    return btoa(str);
  } catch (e) {
    return fallback;
  }
}
